import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute top-0 left-0 w-full h-full flex z-30 items-center justify-center"
}
const _hoisted_2 = ["src"]

import Document from '@/interfaces/Document'
import { close } from 'ionicons/icons'
import { IonIcon } from '@ionic/vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'ImageFullscreen',
  props: {
    imgFullscreen: null
  },
  emits: ["resetImgFullscreen"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'resetImgFullscreen', v: void): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  imgFullscreen: Document
}





function resetImgFullscreen() {
  emits("resetImgFullscreen")
}


return (_ctx: any,_cache: any) => {
  return (props.imgFullscreen.signed_url)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(IonIcon), {
          class: "absolute top-5 left-5 w-7 h-7 cursor-pointer rounded-lg bg-white",
          icon: _unref(close),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (resetImgFullscreen()))
        }, null, 8, ["icon"]),
        _createElementVNode("img", {
          src: props.imgFullscreen.signed_url,
          class: "w-auto max-w-full max-h-full h-auto"
        }, null, 8, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}
}

})